import { render, staticRenderFns } from "./CompleteOrderResumeFloat.vue?vue&type=template&id=07a83b20&scoped=true&"
import script from "./CompleteOrderResumeFloat.vue?vue&type=script&lang=js&"
export * from "./CompleteOrderResumeFloat.vue?vue&type=script&lang=js&"
import style0 from "./CompleteOrderResumeFloat.vue?vue&type=style&index=0&id=07a83b20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a83b20",
  null
  
)

export default component.exports